import { ReactNode } from 'react';

import Page from './Page';
import { NavlinkKey } from '../Navbar';

import './PageHeaderAndMain.scss';

interface PageHeaderAndMainProps {
  children?: ReactNode;
  className?: string;
  activeNavlink?: NavlinkKey;
}

export default function PageHeaderAndMain({ children, className = '', activeNavlink }: PageHeaderAndMainProps) {
  return (
    <Page className={`page-header-and-main ${className}`} activeNavlink={activeNavlink}>
      {children}
    </Page>
  );
}
